export var MediaAssetProviders = /*#__PURE__*/function (MediaAssetProviders) {
  MediaAssetProviders["cloudinary"] = "cloudinary";
  return MediaAssetProviders;
}(MediaAssetProviders || {});
// TODO: must be handled by the provider plugins later
export function getMediaAssetProviderLabel(provider) {
  return provider;
}
export function getMediaAssetProviderOptionsList() {
  return Object.values(MediaAssetProviders).map(provider => {
    return {
      value: provider,
      label: getMediaAssetProviderLabel(provider)
    };
  });
}
export const MEDIA_ASSET_PROVIDER_TOKEN = 'MEDIA_ASSET_PROVIDER_TOKEN';